<div class="dialog-container">
    <div class="dialog-title" [ngClass]="{ 'entete-rouge': data.warn }">
        {{ data.titleLabel || 'Confirmation' }}
    </div>

    <div class="dialog-content" [innerHTML]="data.message"></div>

    <div *ngIf="data.completer" class="dialog-content">
        <p class="mb-1">* <span class="bold text-dark">Compléter : </span>{{ data.messageComplementaireCompleter }}</p>
        <p class="mb-0">** <span class="bold text-dark">Écraser : </span>{{ data.messageComplementaireEcraser }}</p>
    </div>

    <div *ngIf="data.messageCheckboxConfirm" class="dialog-checkbox">
        <label class="checkbox-label">
            <input type="checkbox" [(ngModel)]="enableConfirm" class="checkbox-input" />
            <span class="checkbox-text">{{ data.messageCheckboxConfirm }}</span>
        </label>
    </div>
    <app-wizy-divider></app-wizy-divider>
    <div class="dialog-actions">
        <button
            class="btn btn-raised"
            [ngClass]="data.warn ? 'btn-warn' : 'btn-primary'"
            cdkFocusInitial
            [disabled]="!enableConfirm"
            (click)="onConfirm()"
        >
            <app-wizy-icon-wrapper [iconName]="'check'"></app-wizy-icon-wrapper>
            <span>{{ data.confirmLabel || 'Confirmer' }}</span>
        </button>

        <button *ngIf="data.completer" class="btn" [ngClass]="data.success ? 'btn-success' : 'btn-primary'" (click)="onIgnorer()">
            <app-wizy-icon-wrapper [iconName]="'close'"></app-wizy-icon-wrapper>
            <span>{{ data.completerLabel || 'Compléter' }}</span>
        </button>

        <button class="btn" (click)="onDismiss()">
            <app-wizy-icon-wrapper [iconName]="'close'"></app-wizy-icon-wrapper>
            <span>{{ data.cancelLabel || 'Annuler' }}</span>
        </button>
    </div>
</div>
